import React from 'react';
import styles from './native_select_dropdown.module.scss';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { buildClassName } from 'utils/build-class-name';

export type NativeSelectOption = {
  value: string;
  label: string;
};

export type NativeSelectDropdownProps = {
  value: string;
  options: NativeSelectOption[];
  onChange: (value: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
};


// TODO: replace with MUI Select
export default function NativeSelectDropdown({ value, options, onChange, ariaLabel, disabled = false }: NativeSelectDropdownProps) {
  return (
    <div className={buildClassName(styles.dropdown, disabled && styles.disabled)}>
      <div className={styles.selectWrapper}>
        <select
          className={styles.select}
          value={value}
          onChange={e => onChange(e.target.value)}
          aria-label={ariaLabel}
          disabled={disabled}
        >
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
        <ArrowDropDownIcon className={styles.caret} />
      </div>
    </div>
  );
}


